import { ESalesType } from '../types/offersData';

const salesStartIcon = require('../assets/sales-start.svg');
const salesLeaderIcon = require('../assets/sales-leader.svg');
const salesSoonIcon = require('../assets/sales-soon.svg');

export const SALES_TYPE_ICONS = new Map<ESalesType, string>([
  [ESalesType.SalesStart, salesStartIcon],
  [ESalesType.SalesLeader, salesLeaderIcon],
  [ESalesType.UpcomingSale, salesSoonIcon],
]);
